
export default {
    OnGoingOrders: (data) => window.axios.get(`order/ongoing?total_record=${data.totalrecord}&skip=${data.skip}`),
    getOnGoingSubscription: (data) => window.axios.get(`subscription?search=${data.search}&skip=${data.skip}&total_record=${data.total_record}`),

    PastOrders: (data) => window.axios.get(`order/history?total_record=${data.totalrecord}&skip=${data.skip}`, data)
}